import { computed, ref } from 'vue';
import { createDiscreteApi, ConfigProviderProps, darkTheme, lightTheme } from 'naive-ui';

const themeRef = ref<'light' | 'dark'>('light');

const configProviderPropsRef = computed<ConfigProviderProps>(() => ({
  theme: themeRef.value === 'light' ? lightTheme : darkTheme,
}));

const { dialog } = createDiscreteApi(['dialog'], {
  configProviderProps: configProviderPropsRef,
});

export function useDialog() {
  function destroyAll() {
    dialog?.destroyAll();
  }

  function create(content, option) {
    dialog?.create(content, option);
  }

  function error(content, option) {
    dialog?.error(content, option);
  }

  function info(content, option) {
    dialog?.info(content, option);
  }

  function success(content, option) {
    dialog?.success(content, option);
  }

  function warning(content, option) {
    dialog?.warning(content, option);
  }

  return {
    destroyAll,
    create,
    error,
    info,
    success,
    warning,
  };
}
